import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const WHATSAPP_LINK = 'https://wa.me/message/TNDFTC7M6U4AI1';
export function FinalCTA() {
  return <section className="py-32 px-6 relative overflow-hidden flex flex-col items-center text-center" data-id="element-15">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-gold/5 rounded-full blur-[150px] pointer-events-none" data-id="element-16" />

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto relative z-10" data-id="element-17">
        <h2 className="text-4xl md:text-6xl font-bold tracking-tight mb-8 leading-[1.1]" data-id="element-18">
          Tu e-commerce no se construye{' '}
          <span className="gold-gradient-text" data-id="element-19">mirando desde afuera.</span>
        </h2>

        <p className="text-xl md:text-2xl text-brand-muted mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-20">
          Si hace tiempo venís pensando en empezar, este puede ser el momento de
          dejar de postergar y avanzar con una guía clara.
        </p>

        <motion.a whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-brand-gold text-brand-darker px-10 py-5 rounded-full text-xl font-bold hover:bg-brand-goldLight transition-colors w-full sm:w-auto shadow-[0_0_40px_rgba(212,175,55,0.4)] mb-6" data-id="element-21">
          Quiero empezar ahora
          <ArrowRight className="w-6 h-6" data-id="element-22" />
        </motion.a>

        <p className="text-brand-muted/80 text-sm" data-id="element-23">
          Consultá disponibilidad, planes, descuentos y opciones de pago por
          WhatsApp.
        </p>
      </motion.div>
    </section>;
}